<template>
  <login-form v-if='isLoginForm' :create-link='createLink' @goToForgotPassword='toggleForgotPassword'/>
  <password-form v-else :forgot-password-link="forgotPasswordLink" @goToLogin='backToLogin'/>
</template>

<script>
  export default {
    props: {
      createLink: {
        default: '',
        type: String,
      },
      forgotPasswordLink: {
        default: '',
        type: String,
      }
    },
    data() {
      return {
        isLoginForm: true,
      };
    },
    methods: {
      toggleForgotPassword() {
        this.isLoginForm = false;
      },
      backToLogin() {
        this.isLoginForm = true;
      },
    },
  };
</script>
